import { useQuery } from '@tanstack/react-query';

import { myOutstandingAwpMembersKey, requestMyOutstandingAwpMembers } from './membersApi';

/**
 * The rows of the directory's Outstanding AWP view, at the app's default staleness.
 *
 * No `Failure` variant to handle: `myOutstandingAwpMembers` is a pure read, so infrastructure errors
 * travel the standard GraphQL errors envelope, and the directory shows them as its error state.
 */
export function useMyOutstandingAwpMembers() {
  return useQuery({ queryKey: myOutstandingAwpMembersKey, queryFn: requestMyOutstandingAwpMembers });
}
